// extracted by mini-css-extract-plugin
export var cell = "_51-4";
export var headerCell = "_51-2";
export var rowHeader = "_51-3";
export var table = "_51-1";
export var tableContainer = "_51-0";